export const BANNER_AUTOPLAY_INTERVAL = 4000;

/** The widest a page banner is shown, in CSS px: what getMediaUrl sizes the upload to. */
export const BANNER_IMAGE_WIDTH = 960;

export const BANNER_ASPECT_RATIO = "1450 / 350";
export const BANNER_ASPECT_RATIO_MOBILE = "1450 / 700";
export const BANNER_ASPECT_RATIO_MOBILE_BREAKPOINT = "425px";

/**
 * The wash behind the banner's title, which sits in the bottom-left corner (the
 * top-left on a phone): a pool of color out of that corner, clear over the rest
 * of the artwork.
 *
 * In the mascot's blues rather than the plain black it was, and per color
 * scheme like the other pages' banners (`components/Others/PageHero`): night
 * navy in the dark scheme, the brighter blue in the light one. Both are deep
 * enough for the white title the banner carries.
 */
const overlay = (corner: string, rgb: string, strength: number): string =>
  `radial-gradient(120% 100% at ${corner}, rgba(${rgb}, ${strength}) 0%, rgba(${rgb}, ${strength * 0.45}) 32%, rgba(${rgb}, 0) 62%)`;

const NIGHT = "7, 20, 46";
const DAY = "11, 42, 102";

export const BANNER_TEXT_OVERLAY_GRADIENT = {
  light: overlay("0% 100%", DAY, 0.7),
  dark: overlay("0% 100%", NIGHT, 0.78),
} as const;

export const BANNER_TEXT_OVERLAY_GRADIENT_MOBILE = {
  light: overlay("0% 0%", DAY, 0.7),
  dark: overlay("0% 0%", NIGHT, 0.78),
} as const;

/** A band of shade in from the text's side, laid over the corner wash where a description runs longer than the corner. */
const band = (direction: string, strength: number, end: number): string =>
  `linear-gradient(${direction}, rgba(${NIGHT}, ${strength}) 0%, rgba(${NIGHT}, ${strength * 0.6}) ${end * 0.55}%, rgba(${NIGHT}, 0) ${end}%)`;

export const BANNER_TEXT_BAND = {
  light: band("90deg", 0.6, 62),
  dark: band("90deg", 0.7, 62),
} as const;

/** On a phone the text runs the banner's whole height, so the veil does too. */
export const BANNER_TEXT_BAND_MOBILE = {
  light: `linear-gradient(180deg, rgba(${NIGHT}, 0.6) 0%, rgba(${NIGHT}, 0.4) 100%)`,
  dark: `linear-gradient(180deg, rgba(${NIGHT}, 0.7) 0%, rgba(${NIGHT}, 0.5) 100%)`,
} as const;
